import React from "react";
import { Button, CardActions } from "@mui/material";

const CardActionButtons = ({
  isEditMode,
  onDelete,
  onUpdate,
  onCancel,
  onAccept,
  t,
}) => {
  return (
    <CardActions>
      {isEditMode ? (
        <>
          <Button
            onClick={onDelete}
            sx={{
              color: "#d93025",
              "&:hover": { backgroundColor: "rgba(217, 48, 37, 0.04)" },
            }}
          >
            {t("mapWithComponents.deleteButton")}
          </Button>
          <Button
            onClick={onUpdate}
            variant="contained"
            sx={{
              bgcolor: "#d3af5f",
              color: "#333333",
              "&:hover": { bgcolor: "#c19b4a" },
            }}
          >
            {t("mapWithComponents.updateButton")}
          </Button>
        </>
      ) : (
        <>
          <Button onClick={onCancel} color="inherit">
            {t("mapWithComponents.cancelButton")}
          </Button>
          <Button
            onClick={onAccept}
            variant="contained"
            sx={{
              bgcolor: "#d3af5f",
              color: "#333333",
              "&:hover": { bgcolor: "#c19b4a" },
            }}
          >
            {t("mapWithComponents.saveButton")}
          </Button>
        </>
      )}
    </CardActions>
  );
};

export default CardActionButtons;
